// 权限管理路由
const general: any = [
    {
        path: 'agreement/letter',
        name: 'protocol_attachment',
        meta: {
            pathTitle: 'channel_manage',
            title: '业务附件'
        },
        component: () => import('@/views/agreement/letter.vue')
    },
    {
        path: 'agreement/accord',
        name: 'protocol_online',
        meta: {
            pathTitle: 'channel_manage',
            title: '线上协议'
        },
        component: () => import('@/views/agreement/accord.vue')
    },
    {
        path: 'agreement/invoice',
        name: 'protocol_invoice',
        meta: {
            pathTitle: 'channel_manage',
            title: '发票文件'
        },
        component: () => import('@/views/agreement/invoice.vue')
    }
]
export default general
